import axios from "../../axios";

const updateApptStatus = ({id, status}) => {
  try {
    const { data } = axios.put(`/appointments/status/${id}`, { status });
    return data;
  } catch (e) {
    return null;
  }
}

const getAppointmentsForCheckout = async (query) => {
  let date = new Date().toISOString();
  let ready = ['scheduled', 'in_progress'];
  try {
    const { data } = await axios.get(`/appointments/checkout?appointment_date[$lte]=${date}&status[$in]=${ready.join(',')}&appointment_type[$eq]=customer`);
    return data;
  } catch (e) {
    return null;
  }
}

const deleteAppt = async ({id, remove_all}) => {
  console.log(id);
  let remove_all_query = remove_all ? '?remove_all=true' : '';
  try {
    const { data } = await axios.delete(`/appointments/${id}${remove_all_query}`);
    return data;
  } catch (e) {
    return null;
  }
}

export { updateApptStatus, deleteAppt, getAppointmentsForCheckout };